/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-multiple-empty-lines */

// @ts-nocheck
import { useEffect } from "react";

export const useOnClickOutside = (ref, handler): void => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
